const ROUTE_PATHS = {
  paymentLink: '/payment', // Show Link Details
  linkDetails: '/payment/:token', // Show Link Details
  authentication: '/payment/auth/:token', // Authenticate user
  selectMethod: '/payment/select-method/:token', // Select Payment method
  walletSummary: '/payment/wallet/summary/:token', // Wallet Summary
  paymentSummary: '/payment/method/summary/:token', // Payment method Summary
  manual: '/payment/card/:token', // Manual Payment with apc
  profile: '/payment/profile/:token',
  identityValidation: '/payment/identity/validation/:token',
  waiting: '/payment/waiting/:token',
  error: '/payment/invalid/request',
  completed: '/payment/completed/:token',
  addCard: '/payment/credit-card/add/:token',
  selectCard: '/payment/credit-card/list/:token',
  pay: '/payment/pay/:token',
};

export default ROUTE_PATHS;
